export const Business = () => {
  return (
    <div className="flex justify-center">
      <div className="w-[1920px] flex gap-[70px] pt-[192px]">
        <img
          className="w-[470px] min-w-[470px] h-[470px]"
          src={"/imgs/private/1.png"}
        />
        <div className="flex-1">
          <div className="w-[100%] h-[408px] bg-[#EAF2FF] rounded-[20px] p-[40px]">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[45px] text-[#333333]">
              商业合作
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[22px] text-[#333333] mt-[40px]">
              光年无界全球SD-WAN网络加速业务，专注于为外贸、跨境电商、跨境直播等有出海需求的企业客户提供合规、快速、稳定、安全的跨国网络专线组网服务。采用光年自研K-WAN加速引擎在全球部署节点组建专用骨干网络，打造企业全球组网、跨境办公应用加速、跨境电商加速、跨境直播专线等多种产品。
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[22px] text-[#333333] mt-[20px]">
              旨在帮助出海企业突破地域限制，顺畅连接全球市场，安心运营合规的跨境出海业务。通过硬件CPE(高性能服务器/路由器/旁路/SDK/端口接入)为基础，适配PC\Mac安卓\IOS\浏览器插件等软件实现多平台多场景的支持，实现快速落地接入方式，安装后即可使用。同时支持大型企业私有化定制开发部罢。
            </div>
          </div>
          <div className="mt-[80px] flex items-center gap-[20px]">
            <div className="bg-gradient-to-r from-[#FFFFFF] via-[#1FB4EE] via-[#0076FD] to-[#FFFFFF] h-[10px] w-full "></div>
            <img
              className="w-[220px] h-[220px] min-w-[220px] min-h-[220px]"
              src="/imgs/private/3.png"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
